import { format } from 'date-fns'
import React from 'react'
import styled, { css } from '../config/theme'
import { Status, STATUS } from '../models/Realty'
import Text from './Text'

export default function StatusFlow({ history }: StatusFlowProps) {
  return (
    <div>
      <Text
        tag="h2"
        color="darkGray"
        style={{
          marginTop: 20,
        }}
      >
        Gerenciar negociação
      </Text>
      <Container>
        {history.map((s, index) => (
          <Block
            key={index}
            active
            style={{
              width: `${(1 / history.length) * 100}%`,
            }}
          >
            <DateText>{format(new Date(s.created_at), 'dd/MM/yyyy HH:mm')}</DateText>
            <Label>{STATUS[s.current]}</Label>
          </Block>
        ))}
      </Container>
    </div>
  )
}

export interface StatusFlowProps {
  history: {
    status: Status
    current: Status
    created_at: string
  }[]
}

export interface StatusObj {
  label: string
  status: Status
}

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 40px 0;
  position: relative;
  overflow: auto;
  margin-bottom: 20px;
`

const Block = styled.div<{ active?: boolean }>`
  position: relative;
  border-top: 2px solid ${props => props.theme.color[props.active ? 'darkBlue' : 'lightGray']};
  flex-shrink: 0;
  
  @media screen and (max-width: 800px) {
    width: 200px !important;
  }

  &::before {
    content: " ";
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: -12px;
    left: 50%;
    margin-left: -10px;
    width: 20px;
    height: 20px;
    background-color: #fff;
    border-radius: 100%;
    border: 2px solid ${props => props.theme.color[props.active ? 'darkBlue' : 'lightGray']};
    ${props => props.active && css`
      content: "✓";
      background-color: ${props => props.theme.color.darkBlue};
      color: #fff;
      font-size: 16px;
    `}
  }
`

const Label = styled.div`
  padding: 0 10px;
  padding-top: 25px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  color: ${props => props.theme.color.gray};
`

const DateText = styled.div`
  position: absolute;
  top: -40px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 12px;
`
